import { apiPost, fetchForm, setFormSubmitButtonEnabled } from "./api";
import { updateBasketTimer } from "./basket";
import { Analytics } from "./analytics";
import { debounce } from "./debounce";

$(document).ready(function () {
    // Donation forms
    document.querySelectorAll('form[data-ticketing][name="donation-form"]').forEach((donationForm) => {
        const tierPanel = donationForm.querySelector('.donation-tier-dynamic');
        const amountInput = donationForm.querySelector('input[name="donationAmount"]');
        const existingDonor = donationForm.querySelector('input[name="existingDonor"]');
        const submitButton = donationForm.querySelector('button[type="submit"]');
        const editDonationButton = donationForm.querySelector('button[name="editDonation"]');
        const submitContainer = submitButton ? submitButton.closest('div.hidden') : null;

        const updateSelectedTierTitle = (amount,existing) => {
            let newTier;
            let existingTier;

            // find the tier for our amount
            for (let tier of window.DonationTiers) {
                if (!(tier.min_amount > (amount + existing))) {
                    newTier = tier;
                }

                if (!(tier.min_amount > existing)) {
                    existingTier = tier;
                }
            }

            const tierTitle = tierPanel.querySelector('.tier-title');
            const tierImage = tierPanel.querySelector('.tier-image');
            const tierWording = tierPanel.querySelector('.tier-wording');

            if (amount && (newTier || existingTier)) {
                tierTitle.innerText = newTier?.title ?? existingTier?.title;
                tierImage.src = newTier?.badge ?? existingTier?.badge;

                tierWording.innerText = existingTier?.id == newTier?.id ? 'be' : 'become';

                tierPanel.classList.remove('hidden');
            } else {
                tierPanel.classList.add('hidden');
                tierTitle.innerText = null;
                tierImage.src = null;
            }
        }

        const onAmountChanged = () => {
            let enteredValue = parseFloat(amountInput.value);
            const existingDonation = existingDonor ? parseFloat(existingDonor.value) : 0;

            if (isNaN(enteredValue)) {
                enteredValue = 0;
            }

            if (tierPanel) {
                // should this reflect existing donations? if so, + existingDonation
                updateSelectedTierTitle(enteredValue,existingDonation);
            }

            if (submitContainer) {
                submitContainer.classList.remove('hidden');
            }
        };

        // when entering a donation amount manually, select the tier level for display
        const debounceInput = debounce(onAmountChanged, 500, false);
        amountInput.addEventListener('change', onAmountChanged);
        amountInput.addEventListener('input', debounceInput);

        donationForm.addEventListener('submit', (event) => {
            event.preventDefault();

            fetchForm(event.target).then((resp) => {
                Analytics.updateCartDonation(resp.donationPrevious, resp.donationNow, resp.pathway);

                window.location.href = '/cart';
            }).catch((err) => {
                setFormSubmitButtonEnabled(event.target, true);
            });
        });

        if (editDonationButton) {
            editDonationButton.addEventListener('click', (event) => {
                editDonationButton.parentElement.removeChild(editDonationButton);

                amountInput.type = 'number';
                amountInput.disabled = false;
                amountInput.value = amountInput.getAttribute('data-value');
                amountInput.focus();

                submitButton.classList.remove('hidden');
                submitButton.disabled = false;

                const toggleFieldContainer = donationForm.querySelector('.donation-form-fields');
                if (toggleFieldContainer) {
                    for (let child of toggleFieldContainer.children) {
                        child.classList.toggle('hidden');
                    }
                }
            });
        }

        donationForm.querySelectorAll('button.suggested-donation-button').forEach((suggestionButton) => {
            suggestionButton.addEventListener('click', (event) => {
                amountInput.value = parseFloat(suggestionButton.value);

                if (submitButton) {
                    submitButton.classList.remove('hidden');
                    submitContainer.classList.remove('hidden');
                }
            });
        });
    })

    document.querySelectorAll('button[name="removeDonation"]').forEach((button) => {
        button.addEventListener('click', () => {
            button.disabled = true;

            apiPost('remove-donation-from-basket').then(async (resp) => {
                const json = await resp.json();

                updateBasketTimer(json.basketExpiry, json.basketItemCount);
                Analytics.updateCartDonation(json.donationPrevious, json.donationNow, json.pathway);

                window.location.reload();
            }).catch((err) => {
                button.disabled = false;
            })
        })
    });
});